<template>
    <div v-if="!isDeluxeLayout">
        <Pagination
        :changePage="PageChange" 
        :paginationDetails="paginationDetails" 
        :havePageCount="true"
        ></Pagination>
    </div>
    <div class="clearfix"></div>
    <table :class="isDeluxeLayout ? 'custom-table fixed-width boq-list-table' : 'table table-striped table-bordered'">
            <thead>
                <tr>
                    <!-- <th class="text-center" @click="()=>{ this.toggler = !this.toggler; this.ToggleAll() }">
                        <input type="checkbox" ref="checkAll" v-model="toggler" @change="ToggleAll" />
                    </th> -->
                    <th class="title">{{$t('Name')}}</th>
                    <th class="description">{{$t('Reference')}}</th>
                    <th class="amount"> {{$t('Contract Sum')}}</th>
                    <th class="amount">{{$t('Total Cost')}}</th>
                    <th class="amount"> {{$t('Total Sell')}}</th>
                    <th class="amount"> {{$t('GP Total')}}</th>
                    <th class="status"> {{$t('GP')}}%</th>
                    <th class="status">{{$t('Status')}}</th>
                    <th :class="{ 'actions-heading': isDeluxeLayout }">{{ isDeluxeLayout ? $t('Actions') : '' }}</th>
                </tr>
            </thead>
            <tbody :class="{ 'text-capitalize table-group-divider': !isDeluxeLayout }" >
                <tr v-if="filteredBoqDocs.length==0">
                    <td colspan="9" class="text-center" >
                        {{$t('No data Found')}}
                    </td>
                </tr>
                <tr  v-for="(item, key) in filteredBoqDocs" :key="key" @click="ClickTd(item._id)" >
                    <!-- <td  class="text-center" >
                        <input type="checkbox" v-model="selected"  :value="item._id" />
                    </td> -->
                    <td class="title" :title="$t('Click to View Items')">
                        <router-link :to="{name : 'BoqBuilder', params : {id : item._id}}" class="link-item-route"> 
                            {{item.name}} 
                        </router-link>
                        
                    </td>
                    <td class="description">{{item.reference?.quotationNumber || '-'}}</td>
                    <td class="amount text-end">{{ReformatNumber(item.targetBudget)}}</td>
                    <template v-if="item.summary">
                        <td class="amount text-end">{{ReformatNumber(item.summary.costTotal)}}</td>
                        <td class="amount text-end">{{ReformatNumber(item.summary.sellTotal)}}</td>
                        <td class="amount text-end">{{ReformatNumber(item.summary.gp)}}</td>
                        <td class="status text-end">{{GetGpPercent(item.summary)}}%</td>
                    </template>
                    <template v-else>
                        <td class="amount text-end">0.00</td>
                        <td class="amount text-end">0.00</td>
                        <td class="amount text-end">0.00</td>
                        <td class="status text-end">0%</td>
                    </template>
                    <td class="status">
                        <span :class="GetStatusClass(item.approvalStage)">{{GetStatusName(item.approvalStage)}}</span>
                    </td>
                    <td :class="{ 'actions-cell': isDeluxeLayout }">
                        <div v-if="isDeluxeLayout" class="actions">
                            <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#BoqModalUpdate"
                            v-if="permission.indexOf(ModuleActionList.BOQ_EDIT)>-1"
                            @click.stop="GetBoq(item._id, item.name, item.currencyId._id, item.reference)"
                            :title="$t('Update BoQ')"
                            >
                                <svg class="boq-action-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.862 4.48725L18.549 2.79925C18.9007 2.44757 19.3777 2.25 19.875 2.25C20.3724 2.25 20.8494 2.44757 21.201 2.79925C21.5527 3.15092 21.7503 3.6279 21.7503 4.12525C21.7503 4.62259 21.5527 5.09957 21.201 5.45125L6.83203 19.8202C6.30336 20.3486 5.6514 20.737 4.93503 20.9502L2.25003 21.7502L3.05003 19.0652C3.26331 18.3489 3.65167 17.6969 4.18003 17.1682L16.863 4.48725H16.862ZM16.862 4.48725L19.5 7.12525" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <router-link :to="{name : 'BoqBuilder', params : {id : item._id}}" :title="$t('View BoQ')">
                                <svg class="boq-action-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.03603 12.322C1.96702 12.1146 1.96702 11.8904 2.03603 11.683C3.42303 7.51 7.36003 4.5 12 4.5C16.638 4.5 20.573 7.507 21.963 11.678C22.033 11.885 22.033 12.109 21.963 12.317C20.577 16.49 16.64 19.5 12 19.5C7.36203 19.5 3.42603 16.493 2.03603 12.322Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M15 12C15 12.7956 14.684 13.5587 14.1214 14.1213C13.5587 14.6839 12.7957 15 12 15C11.2044 15 10.4413 14.6839 9.87871 14.1213C9.3161 13.5587 9.00003 12.7956 9.00003 12C9.00003 11.2044 9.3161 10.4413 9.87871 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7957 9 13.5587 9.31607 14.1214 9.87868C14.684 10.4413 15 11.2044 15 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </router-link>
                            <button
                            type="button"
                            v-if="permission.indexOf(ModuleActionList.BOQ_EDIT)>-1"
                            @click.stop="CreateDuplicate(item._id, item.name, item.currencyId._id)"
                            data-bs-toggle="modal"
                            data-bs-target="#BoqModalCreateDuplicate"
                            :title="$t('Duplicate BoQ')"
                            >
                                <svg class="boq-action-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.75 17.25V20.625C15.75 21.246 15.246 21.75 14.625 21.75H4.875C4.254 21.75 3.75 21.246 3.75 20.625V7.875C3.75 7.254 4.254 6.75 4.875 6.75H6.75C7.257 6.75 7.759 6.791 8.25 6.874M15.75 17.25H19.125C19.746 17.25 20.25 16.746 20.25 16.125V11.25C20.25 6.79 17.007 3.089 12.75 2.374C12.255 2.291 11.754 2.25 11.25 2.25H9.375C8.754 2.25 8.25 2.754 8.25 3.375V6.875M15.75 17.25H9.375C8.754 17.25 8.25 16.746 8.25 16.125V6.875M20.25 13.5V11.625C20.25 9.761 18.739 8.25 16.875 8.25H15.375C14.754 8.25 14.25 7.746 14.25 7.125V5.625C14.25 3.761 12.739 2.25 10.875 2.25H9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <button
                            type="button"
                            v-if="item.approvalStage > 1"
                            @click.stop="GoToHistory(item._id)"
                            :title="$t('History')"
                            >
                                <svg class="boq-action-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <button
                            type="button"
                            v-if="permission.indexOf(ModuleActionList.BOQ_ITEM_REMOVE)>-1 && item.approvalStage==1"
                            @click.stop="DeleteBoq(item._id, item.name)"
                            :title="$t('Delete BoQ')"
                            >
                                <svg class="boq-action-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                        <template v-else>
                            <router-link :to="{name : 'BoqBuilder', params : {id : item._id}}" :class="GetActionClass('primary')" :title="$t('View BoQ')">
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </router-link>
                            <button 
                            :class="GetActionClass('primary')"
                            data-bs-toggle="modal" 
                            data-bs-target="#BoqModalUpdate" 
                            v-if="permission.indexOf(ModuleActionList.BOQ_EDIT)>-1"
                            @click.stop="GetBoq(item._id, item.name, item.currencyId._id, item.reference)"
                            :title="$t('Update BoQ')"
                            ><i class="fa-solid fa-edit"></i></button>

                            <button 
                            :class="GetActionClass('primary')"
                            v-if="permission.indexOf(ModuleActionList.BOQ_EDIT)>-1"
                            @click.stop="CreateDuplicate(item._id, item.name, item.currencyId._id)"
                            data-bs-toggle="modal" 
                            data-bs-target="#BoqModalCreateDuplicate" 
                            :title="$t('Duplicate BoQ')"
                            ><i class="fa-solid fa-copy"></i></button>

                            <button 
                            v-if="item.approvalStage > 1"
                            :class="GetActionClass('primary')"
                            @click.stop="GoToHistory(item._id)"
                            :title="$t('History')"
                            ><i class="fa-solid fa-clock-rotate-left"></i></button>

                            <button 
                            :class="GetActionClass('danger')"
                            v-if="permission.indexOf(ModuleActionList.BOQ_ITEM_REMOVE)>-1 && item.approvalStage==1"
                            @click.stop="DeleteBoq(item._id, item.name)"
                            :title="$t('Delete BoQ')"
                            ><i class="fa-solid fa-trash-can"></i></button>
                        </template>
                    </td>
                </tr>
            </tbody>
    </table>
</template>


<script>
import  {mapGetters, mapActions} from 'vuex'
import {ReformatDate, ReformatNumber,ApprovalStageBoqObj, ModuleActionList} from '@/helpers/utilities.js'
import Pagination from '@/components/layout/Pagination.vue'

export default {
    name : 'TableBoq',
    props: {
        GetBoq : Function,
        CreateDuplicate : Function,
        search : String,
        UpdateSelectedValue : Function,
        DeleteBoq :Function,
        statusFilter : {
            type : String,
            default : ''
        }
    },
    components :{
        Pagination
    },
    data(){
        return {      
            toggler : false,
            selected : [],
            ApprovalStageBoqObj : ApprovalStageBoqObj,
            ModuleActionList : ModuleActionList
        }
    },
    methods : {
        ...mapActions(['GetBoqListRun']),
        formatDate(value){
            return ReformatDate(value)
        },
        ReformatNumber: ReformatNumber,
        GetGpPercent(summary){
            if(!summary || !summary.sellTotal){
                return '0.00'
            }

            return ReformatNumber((summary.gp / summary.sellTotal) * 100)
        },
        GetActionClass(type){
            if(this.isDeluxeLayout){
                return ''
            }

            return type == 'danger' ? 'btn btn-outline-danger btn-action' : 'btn btn-outline-primary btn-action me-1'
        },
        GetStatusName(stage){
            const name = ApprovalStageBoqObj[stage - 1]?.name || '-'
            if(!this.isDeluxeLayout){
                return name
            }

            return name.toLowerCase().replace(/\b\w/g, (letter)=>letter.toUpperCase())
        },
        GetStatusClass(stage){
            if(!this.isDeluxeLayout){
                return 'badge ' + (ApprovalStageBoqObj[stage -1]?.color || 'bg-secondary text-white')
            }

            if([5,8].indexOf(stage)>-1){
                return 'pill-completed'
            }

            if([2,3,4].indexOf(stage)>-1){
                return 'pill-in-progress'
            }

            if(stage==6){
                return 'pill-warning'
            }

            if([1,7].indexOf(stage)>-1){
                return 'pill-planning'
            }

            return 'pill-hold'
        },
        PageChange(page){
            const self = this
            const projectId = self.$route.params.id
            self.GetBoqListRun({id : projectId,page : page, search : self.search}).catch()
        },
        GoToHistory(id){
            this.$router.push('/boq/history/'+id)
        },
        ToggleAll(){
            const self = this
            const ids = this.boqList.docs.map(u=>u._id)
            if(self.toggler){
                const toBePushed = ids.filter(u=>!self.selected.includes(u))
                if(toBePushed.length>0){
                    self.selected.push(...toBePushed)
                }
            }
            else{
                this.selected = self.selected.filter(u=>!ids.includes(u))
            }
        },
        ClickTd(id){
            const index = this.selected.indexOf(id)
            if(index == -1 ){
                this.selected.push(id)
            }else{
                this.selected.splice(index,1)
            }
        },
        
    },
    computed : {
        ...mapGetters(['boqList','permission','projectInfo']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        paginationDetails(){
            const totalPages = Math.max(Number(this.boqList.totalPages) || 1, 1)
            const page = Math.min(Math.max(Number(this.boqList.page) || 1, 1), totalPages)

            return {
                totalPages,
                page
            }
        },
        filteredBoqDocs(){
            const docs = this.boqList.docs || []
            if(!this.statusFilter){
                return docs
            }

            return docs.filter((item)=>String(item.approvalStage) === this.statusFilter)
        }
    },
    watch : {
        selected :{
            handler(newValue){
                this.UpdateSelectedValue(newValue)
            },
            deep : true
        }
        
    }

}
</script>
